

define(['angular'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-device-info', ['squid']).factory('$DeviceInfo', function ($window, $meta, $logger) {
        var userAgent = $window.navigator.userAgent;
        var standalone = $window.navigator.standalone;
        var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
        var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;

        // Supports iOS and Android. Updated / more accurate method of detecting webviews
        function isWebView() {
            var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;

            var ios = /iphone|ipod|ipad/i.test(ua),
                android = /Android/i.test(ua);

            if (ios) {
                // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
                // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
                var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);

                if (!standalone && ios_uiwebview && !isSafariViewController()) {
                    // uiwebview
                    logWebView('iOS');
                    return true;
                }
            } else if (android) {
                // not iOS, Android platform handling
                // Whitelist for x-requested-with header values for web view detection
                var allowedXRequestedWithRegexMap = {
                    ajax: /XMLHttpRequest/i,
                    baiduBrowser: /com.baidu.browser.inter/i,
                    operaMini: /com.opera.mini.native/i,
                    maxthon: /com.mx.browser/i,
                    litterPenguinBrowser: /com.explore.web.browser/i
                };
                var xRequestedWithHeaderVal = $meta.requestHeaders['x-requested-with'];

                if (xRequestedWithHeaderVal) {
                    // check if x-requested-with header val is in whitelist
                    for (var key in allowedXRequestedWithRegexMap) {
                        if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
                            if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
                                return false;
                            }
                        }
                    }
                    logWebView('Android');
                    return true;
                }
            }

            return false;

            function logWebView(device) {
                if (!logEnabled) {
                    return;
                }
                // cal log
                $logger.info('WebView :: ' + device);
            }
        }

        /**
         * Check if the given the user-agent string is belongs to a device.
         */
        function isDevice() {
            if (angular.isString(userAgent)) {
                return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
            }

            return false;
        }

        /**
         * Check if the given the user-agent string is belongs to a tablet.
         */
        function isTablet() {
            if (angular.isString(userAgent)) {
                return TABLET_PATTERN.test(userAgent);
            }

            return false;
        }

        /**
         * Check if the given the user-agent string is belongs to a mobile
         */
        function isMobile() {
            return isDevice(userAgent) && !isTablet(userAgent);
        }

        /**
         * Get the mobile platform value given the user-agent string.
         */
        function getDevicePlatform() {
            if (angular.isString(userAgent)) {
                var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);

                if (matched && matched.length > 0) {
                    return matched[0];
                }
            }
        }

        /**
         * Check if the give user agent is from an app.
         */
        function isApp(uaString) {
            userAgent = uaString || userAgent;

            if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
                if (getDevicePlatform(userAgent) === 'Android') {
                    return (/Version\/\d.\d/i.test(userAgent)
                    );
                }

                return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
                );
            }

            return false;
        }

        function isSafariViewController() {
            if (angular.isString(userAgent)) {
                var ios = /iphone|ipod|ipad/i.test(userAgent);
                return ios && $window.indexedDB && isApp();
            } else {
                return false;
            }
        }

        /**
         * Get the device capabilities
         */
        function getCapabilities() {
            var capabilities = {},
                device = DEVICE_PATTERN.test(userAgent),
                tablet = TABLET_PATTERN.test(userAgent),
                app = isApp(userAgent);

            if (angular.isString(userAgent)) {
                capabilities.isWireless = device || tablet;
                capabilities.isTablet = tablet;
                capabilities.isMobile = device && !tablet;
                capabilities.isDesktop = !device;
                capabilities.isApp = app;
            }

            return capabilities;
        }

        /**
         * Get various AppIntegrationType
         */
        function getAppIntegrationType() {
            var app_int_type;
            if (isDevice()) {
                if (isApp()) {
                    if (isSafariViewController()) {
                        app_int_type = 'SFVC';
                    } else {
                        app_int_type = 'WebView';
                    }
                } else {
                    app_int_type = 'Browser';
                }
            }
            return app_int_type;
        }

        return {
            isDevice: isDevice,
            isTablet: isTablet,
            isMobile: isMobile,
            isApp: isApp,
            isSafariViewController: isSafariViewController,
            getCapabilities: getCapabilities,
            getAppIntegrationType: getAppIntegrationType,
            isWebView: isWebView
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-device-info/dist/index.js
// module id = ./components/xo-device-info/dist/index.js
// module chunks = 1